exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wizard-header__back[data-v-866d191a]{min-width:0;padding:0}.wizard-header__title[data-v-866d191a]{font-size:2rem;width:80%}", ""]);

// exports
